import React from 'react'

import './Main.scss'

const Main = _ => {

    return (
        <main>
            <div>
                <p>Olá,</p>
                <span>Eu sou Danilo</span>
                <p>Freelance & Front End Jr.</p>
            </div> 
            <div>
                <img src="../../img/frontendmain.png"  alt="" />
            </div>     
        </main>
    )

}

export default Main